export const blog = {
  // Bare name; the brand suffix is composed at the call site.
  // A literal `|` here is read by vue-i18n as a plural delimiter.
  pageTitle: 'Blog',
  metaDescription: 'Insights on Kubernetes, cloud hosting and container technologies. Practical articles for developers and IT decision-makers.',
  heading: 'Blog',
  subtitle: 'Insights on Kubernetes, cloud and container technologies.',
  readMore: 'Read more',
  publishedOn: 'Published on {date}',
  minuteRead: '{n} min read',
  backToBlog: 'Back to blog',
  noPosts: 'No posts yet.',
  tags: 'Tags',
  allPosts: 'All posts',
  by: 'by'
} as const
